import { randBoolean, randNumber, randText } from '@ngneat/falso';

import { ComponentType, type StyleOptionColourLink } from '../../gql';

import { mockComponentColour } from './mockComponentColour';

const COMPONENT_TYPES: Array<ComponentType> = [
    ComponentType.ZipperTeeth,
    ComponentType.ZipperTape,
    ComponentType.ZipperSlider,
    ComponentType.Standard,
];

const mockStyleOptionColourLink = (
    overwrite?: Partial<StyleOptionColourLink>
): StyleOptionColourLink => ({
    styleOptionNumber: randNumber({ min: 1000, max: 9999 }),
    comment: randBoolean() ? randText() : undefined,
    componentColours: Array.from(
        { length: randNumber({ min: 1, max: 3 }) },
        () => {
            const randomType =
                COMPONENT_TYPES[
                    randNumber({ min: 0, max: COMPONENT_TYPES.length - 1 })
                ];
            return mockComponentColour(randomType);
        }
    ),
    ...overwrite,
    ['__typename']: 'StyleOptionColourLink',
});

export { mockStyleOptionColourLink };
